export const USE_DUPLICATE_WORKFLOW_MODAY_KEY = 'workflows-duplicate-workflow'
